<div id="folderView" class="mb-3">
    <p-select-button [options]="statusOptions" [(ngModel)]="selectedStatus" optionLabel="label" optionValue="value"
        class="mb-3" styleClass="w-full md:w-[30rem]" (onChange)="updateProcedings($event)">
        <ng-template #item let-item>
            <div>
            <i [class]="item.icon"></i> <br/>{{ item.label }}
            </div>
        </ng-template>
    </p-select-button>
    <p-tree [value]="foldersTree" [lazy]="true" (onNodeExpand)="loadSubFolders($event)"  [contextMenu]="fcm"
        highlightOnSelect="true" (onNodeSelect)="selectNode($event)" (onContextMenuSelect)="goToAdvSearch();"
        selectionMode="single" [(selection)]="selectedFolder" emptyMessage="No Folders Found"
        styleClass="w-full md:w-[30rem]" >
        <ng-template let-node pTemplate="togglericon">
            <i class="pi" 
            [ngClass]="{'pi-chevron-down' : node, 'pi-chevron-right': !node}" 
            style="margin-right: 0.5rem; cursor:pointer;"
            (click)="$event.stopPropagation();"></i>
        </ng-template>

        <ng-template let-node pTemplate="default">
           <i class="pi pi-folder"></i> {{ node.label }}
        </ng-template>
    </p-tree>
    <p-contextmenu #fcm [model]="contextMenuItems" />
</div>